import React from 'react'
import { LOGIN, LOGOUT } from './AuthType'
import { ClearSession } from '../../utils/Auth/AuthHelpers'

export function SetLogin(data: object) {
    return { type: LOGIN, payload: { ...data, isLogin: "Yes" } }
}
export function SetLogout() {
    ClearSession()
    return { type: LOGOUT, payload: {isLogin: "No" } }
}
